<template>
  <div class="event">
    <div class="pay">
      <Header :name="$t('payment.services.' + $route.params.payment)" :min="_.get(providerInfo, 'min_pay', '')" :max="_.get(providerInfo, 'max_pay', '')"/>
      <form class="app-pay-form" v-if="is_step == 1">
        <Loader v-if="loading" :style="!isMobile ? 'margin-top: -35px;margin-bottom: 50px;' : ''" />
         <slot v-if="!loading">
            <div class="col">
              <div class="inline-form">
                <label>Tutar</label>
                <input :type="isMobile ? 'tel' : 'number'" placeholder="Yatırım tutarınızı yazınız" v-model="form.amount">
              </div>
            </div>
            <div class="col">
              <ButtonLoader @click.native="fetchData" :type="'button'" class="primary block" :loader="false" :text="'Ödemeyi Başlat'" />
            </div>
         </slot>
      </form>
      <form class="app-pay-form" @submit.prevent="send" v-if="is_step == 2">
          <div class="pay-info">
            <h3>Ödeme yapılacak hesap detayları</h3>
            <div class="alert">
                  <div style="font-size: 15px; margin: 5px 0;">Ad Soyad : <strong>{{ accountInfo.name }}</strong></div>
                  <div style="font-size: 15px; margin: 5px 0;">Hesap No : <strong style="color: var(--client-c3)">{{ accountInfo.account }}</strong></div>
            </div>
            <br>
          </div>
          <div class="col">
            <div class="row">
              <div class="col">
                <ButtonLoader class="primary block" :loader="btnLoading" :text="'Para Yatır'" />
              </div>
            </div>
          </div>
      </form>
    </div>
  </div>
</template>

<script>
  import Header from '../../../../components/User/Pay/Header'
  import Form from '../../../../components/User/Pay/Form'

  export default{
    props: ['providerInfo'],
    data(){
      return{
        form: {
            amount: null,
            provider: 'papara',
            account_id:null,
        },
        loading: false,
        btnLoading: false,
        cancelBtnLoading: false,
        is_step : 1,
        details: {},
        transaction_id: null,
      }
    },
    created(){
    },
    methods:{
      fetchData() {
        this.loading = true;
        axios.get('/user/wallet/deposit/oto_papara/account', { params: { ...this.form }})
        .then((response) => {
            //this.details          = response.data.details;
            this.accountInfo = response.data.account;
            this.form.account_id  = response.data.account.account_id;
            this.is_step          = 2;
        })
        .catch((err) => {
        })
        .finally(() => {
          this.loading = false;
        });
      },
      send(){
  		  this.btnLoading = true;
        axios.post('/user/wallet/deposit/oto_papara/create', this.form)
        .then((response) => {
          if (response.data.status) {
            this.$store.dispatch('wallet/setToPending', true);
            this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message })
          };
        })
        .catch((err) => {
        })
        .finally(() => {
          this.btnLoading = false;
        });
      },
    },
    components:{
      Header,
      Form
    }
  }

</script>